import * as React from 'react';
import linkExternal from '../../../assets/linkExternal.svg';
import { IconProps } from '../../typescriptHelpers';

interface LinkExternalIconProps extends IconProps {
    style?: React.CSSProperties;
}

const LinkExternalIcon: React.FC<LinkExternalIconProps> = ({ width, height, style }: LinkExternalIconProps) => {
    return <img src={linkExternal} width={width} height={height} style={style ? { ...style } : {}} />;
};

export default LinkExternalIcon;
